import { ca } from '@cian/analytics';

export const trackingAddVacancy = (id: number) => {
  ca('event', {
    action: 'success_add_vacancy',
    category: 'Vacancies',
    label: id,
    name: 'oldevent',
  });
};

export const trackingEditVacancy = (id: number) => {
  ca('event', {
    action: 'change_vacancy',
    category: 'Vacancies',
    label: id,
    name: 'oldevent',
  });
};

export const trackingShowContacts = (id: number) => {
  ca('event', {
    action: 'phone-view',
    category: 'Vacancies',
    label: id,
    name: 'oldevent',
  });
};
export const trackingDeleteVacancy = (id: number) => {
  ca('event', {
    action: 'delete_vacancy',
    category: 'Vacancies',
    label: id,
    name: 'oldevent',
  });
};

export const trackingSearchVacancies = (searchQuery: string) => {
  ca('event', {
    action: 'search',
    category: 'Vacancies',
    label: searchQuery,
    name: 'oldevent',
  });
};

export const trackingShowFullDescription = (id: number) => {
  ca('event', {
    action: 'show_more',
    category: 'Vacancies',
    label: id,
    name: 'oldevent',
  });
};
